module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#home",
      toString: function () {
        return this.url;
      }
    }